//GeneratorFlag:[NoChange]
import StaticPage from './static-page';

export default {StaticPage}
export{StaticPage}